import axios from "axios";

export const state = {
    bookstore: [],
};

export const getters = {
    bookstore: state => state.bookstore,
};

export const mutations = {
    setBookStore(state, newValue) {
        state.bookstore = newValue
    },
};

export const actions = {
    fetchBooks({ commit }) {
        axios.get('/bookstore').then(res => {
            commit('setBookStore', res.data.bookstore)
        })
    },
    
//     filterBooks({commit}, {booktitle}) { 
//         let formData = new FormData();
//         formData.append("", booktitlee);
//         let url = "/filterbooks";
//         axios.post(url, formData).then((response) => {
//             commit('setBooks', response.data.books)
//         })
//     },
};
